// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'user-star-solid';

export const Component = () => (
  <g
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeMiterlimit='4.167'
  >
    <path d='M.5 12.89c0-2.81 2.325-5.043 5.085-5.043 1.018 0 2.035.288 2.834.865M2.462 3.597c0 1.73 1.38 3.098 3.123 3.098 1.744 0 3.124-1.369 3.124-3.098S7.33.5 5.585.5C3.842.5 2.462 1.869 2.462 3.597z' />
    <path
      fill='currentColor'
      d='m13.504 8.712 1.163 2.521h2.252c.29 0 .581.216.581.504 0 .145-.073.289-.218.433l-1.962 1.945 1.09 2.52c.145.289 0 .65-.29.793a.626.626 0 0 1-.509 0l-2.615-1.44-2.616 1.44c-.29.144-.654.072-.799-.216a.61.61 0 0 1 0-.504l1.09-2.521-2.034-2.017c-.218-.216-.218-.577-.073-.793.145-.144.29-.216.436-.216h2.252l1.162-2.521c.146-.288.509-.432.8-.216a.565.565 0 0 1 .29.288z'
    />
  </g>
);

export const viewBox = '0 0 18 18';
